import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Constants } from './../app.constants';
@Injectable({
  providedIn: 'root'
})
export class UserprivilegeService {

  constructor(private router: Router,) {

  }

  public getLoginUser_CurrentScreenPrivileges(screenName: String, actionName: String): boolean {
    if (!localStorage.getItem('FeatureActions')) {
      return
    }
    if (!this.getScreenPrivileges()) {
      this.logOut();
    } else {
      let currentFeatureActions: any = JSON.parse(localStorage.getItem('FeatureActions'));
      let obj = currentFeatureActions.find(obj => obj.featureName.trim() == screenName.trim());
      return obj.actions.find(obj => obj.actionName.trim() == actionName.trim()) ? true : false;
    }
  }

  public hasAddEditPrivilege(screenName: String): boolean {
    return this.getLoginUser_CurrentScreenPrivileges(screenName, Constants.AddEditAction);
  }
  public hasActivateDeActivatePrivilege(screenName: String): boolean {
    return this.getLoginUser_CurrentScreenPrivileges(screenName, Constants.ActivateDeactivateAction);
  }
  public hasExportPrivilege(screenName: String): boolean {
    return this.getLoginUser_CurrentScreenPrivileges(screenName, Constants.ExportAction);
  }

  getScreenPrivileges() {
    //debugger;
    if (!localStorage.getItem('FeatureActions')) {
      this.logOut();
    }
    let routUrl = this.router.url.split("/");
    let currentPageAccessedName = routUrl[routUrl.length - 1];
    let currentFeatureActions: any = JSON.parse(localStorage.getItem('FeatureActions'));
    let found = false;
    currentFeatureActions.forEach((element, index, array) => {
      let obj = element.url.split("/");
      let tempName = obj[obj.length - 1]
      if (element.featureId == 58) {
        found = true;
      } else if (currentPageAccessedName == tempName) {
        found = true;
      }
    });
    return found;
  }

  logOut() {
    //localStorage.clear();
    // localStorage.removeItem("CurrentInBoundCallDetails")   
    this.router.navigate(['/base/dashboard/page-not-found']);
    //  localStorage.removeItem("FeatureActions");

  }

}
